// ........Imports......
import React, { useState, useEffect } from 'react';
import Cookies from "universal-cookie";
import { useSelector, connect } from 'react-redux';
import useWebOtpAutofill from "../../../utils/useWebOtpAutofill";

// .....Action imports......
import {
    postUserLoginSignupOtp,
} from "../../../../store/slices/Registration/CommonSlices";

// Main OTP Input component
const OtpInput = (props) => {
    // State variables
    const cookies = new Cookies();
    const [otp, setOtp] = useState('');
    const [error, setError] = useState(null);
    const [focused, setFocused] = useState(false);

    // Extracting data from Redux state
    const { loginData, loginDataLoading } = useSelector((state) => state.usersCommonData)

    // Effect to handle resend OTP timer when props.usersLoginSignupOtp changes
    useEffect(() => {
        if (props.usersLoginSignupOtp) {
            props.resendOtpTimer()
        }
    }, [props.usersLoginSignupOtp])

    // Effect to set the remaining seconds for OTP countdown on component mount
    useEffect(() => {
        props.setRemainingSeconds(Math.abs(localStorage.getItem("remainingSeconds") ? Math.abs(30 - Math.abs(localStorage.getItem("remainingSeconds") - new Date().getSeconds())) : 0))
    }, [])

    // Effect to manage the countdown interval for resending OTP
    useEffect(() => {
        const countdownInterval = setInterval(() => {
            if (props.remainingSeconds > 0) {
                props.setRemainingSeconds(prevSeconds => prevSeconds - 1);
            } else {
                clearInterval(countdownInterval);
            }
        }, 1000);
        if (props.remainingSeconds < 3) {
            localStorage.removeItem("remainingSeconds");
        }
        return () => clearInterval(countdownInterval);
    }, [props.remainingSeconds])

    // Effect to handle errors and loading state based on loginData changes
    useEffect(() => {
        if (loginDataLoading) {
            setError(null)
        } else if (loginData?.otp_response == false && props.values.otp?.length == 4 && loginData?.otp_on) {
            setError(loginData?.message)
        }
    }, [loginData, loginDataLoading])

    // Auto-detect OTP via WebOTP API (SMS autofill without user tapping a suggestion),
    // then submit it the same way typing the 4th digit does
    const restartOtpAutofill = useWebOtpAutofill((code) => {
        props.setFieldValue("otp", code);
        setOtp(code);
        props.handleOtpSubmit(null, null, code);
    }, "(login)");

    // Function to call OTP API
    const otpApiCall = (field, fieldValue) => {
        restartOtpAutofill();
        setOtp("");
        setError(null);
        props.setFormikValues((prev) => ({ ...prev, "otp": "" }));
        let param = {};
        param.otp_on = props.values?.mobile && !props.values?.email ? "mobile" : "email";
        param.otp_action = "send";
        if (props.values?.mobile && !props.values?.email) {
            param.isd_code = "+91";
            param.mobile_number = props.values?.mobile
        } else {
            param.email = props.values?.email
        }
        param.current_url = window.location.href;
        props.setFormCurrentState((prev) => ({ ...prev, sendOtpToMobile: param }))
        props.dispatch(postUserLoginSignupOtp(param));
    }

    // Function to handle OTP input change
    const handleChange = (e) => {
        const sanitizedValue = e.target.value?.replace(/[^\d]/g, '');
        props.setFieldValue("otp", sanitizedValue);
        setOtp(sanitizedValue);
        if (sanitizedValue?.length == 4) {
            props.handleOtpSubmit(null, null, sanitizedValue)
        }
    };

    return (
        <div className={error ? "careers_register_form_card invalid_field multi_check_padding" : otp ? "careers_register_form_card white_bg multi_check_padding" : "careers_register_form_card multi_check_padding"}>
            <div className="otp_field_input">
                <input
                    type="text"
                    name={"otp"}
                    className="input_type_text"
                    value={otp}
                    inputMode="numeric"
                    pattern="\d{4}"
                    autoComplete="one-time-code"
                    maxLength={4}
                    onChange={(e) => {
                        handleChange(e)
                    }}
                    onFocus={() => {
                        setFocused(true)
                    }}
                    onBlur={() => { setFocused(false) }}
                    required />
            </div>
            <span className={focused || otp ? "floating_label_active" : "floating_label"}>
                Please enter OTP
            </span>

            {/* Show Timer to resend the OTP */}
            {props.remainingSeconds ? (
                <div className="resend_otp resend_otp_disabled">
                    <span className='resend_otp_deactivate'>Resend OTP in</span>
                    <span className='resend_otp_time'>
                        <span>{`${props.remainingSeconds % 60}`}</span> sec
                    </span>
                </div>
            ) : (
                (props.usersLoginSignupOtp || cookies.get("loginState")?.sendOtpToMobile?.otp_action === "send") && (
                    <div onClick={() => {
                        otpApiCall()
                    }} className="resend_otp">
                        <span className='resend_otp_active'>Resend OTP</span>
                    </div>
                )
            )}

            {/* Show validation message for otp field */}
            {error &&
                <div className="invalid_card">
                    <span className="invalid_card_text">{error}</span>
                </div>}

        </div>
    )
}
// Mapping state from Redux store to component props
const mapStateToProps = (state) => {
    return {
        usersOtpCheck: state.usersCommonData?.userLoginSignupOtp,
        usersAuthentication: state.usersCommonData?.userAuthentication,
        userAuthenticationErrors: state.usersCommonData?.userAuthenticationError,
        geolocationData: state.usersCommonData?.geoLocation,
        loginDatas: state.usersCommonData?.loginData,
        loginDatasLoading: state.usersCommonData?.loginDataLoading,
        loginDatasError: state.usersCommonData?.loginDataError,
        usersLoginSignupOtp: state.usersCommonData?.userLoginSignupOtp,
        usersLoginSignupOtpError: state.usersCommonData?.userLoginSignupOtpError,
        updateProfileData: state.usersCommonData?.updateProfile,
        emailDomainDatas: state.usersCommonData?.emailDomainData,
        countryCodeData: state.usersCommonData?.countryCode,
        userAuthenticationEmail: state.usersCommonData?.userAuthenticationEmail,
        userAuthenticationEmailError: state.usersCommonData?.userAuthenticationEmailError,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        dispatch,
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(OtpInput);